import {
  ILoadable,
  LoadableStatus,
} from './Utils';

export const mapFuncOverOneLoadable = <Input, Output>
  (func: (input: Input) => Output) =>
    (loadable: ILoadable<Input>): ILoadable<Output> => {

  let result: ILoadable<Output>;
  if (loadable.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (loadable.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (loadable.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: input} = loadable;
    const output = func(input);
    result = {
      status: LoadableStatus.Present,
      data: output,
    };
  }
  return result;
};

export const mapFuncOverOneLoadableAndOneNormal = <Input1, Input2, Output>
  (func: (input1: Input1, input2: Input2) => Output) =>
    (loadable: ILoadable<Input1>, normal: Input2): ILoadable<Output> => {

  let result: ILoadable<Output>;
  if (loadable.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (loadable.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (loadable.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: input} = loadable;
    const output = func(input, normal);
    result = {
      status: LoadableStatus.Present,
      data: output,
    };
  }
  return result;
};

export const mapFuncOverTwoLoadables = <Input1, Input2, Output>
  (func: (input1: Input1, input2: Input2) => Output) =>
    (loadable1: ILoadable<Input1>, loadable2: ILoadable<Input2>): ILoadable<Output> => {

  let result: ILoadable<Output>;
  if (loadable1.status === LoadableStatus.Initial ||
      loadable2.status === LoadableStatus.Initial) {

    result = {status: LoadableStatus.Initial};
  } else if (loadable1.status === LoadableStatus.Loading ||
              loadable2.status === LoadableStatus.Loading) {

    result = {status: LoadableStatus.Loading};
  } else if (loadable1.status === LoadableStatus.NotPresent ||
              loadable2.status === LoadableStatus.NotPresent) {

    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: input1} = loadable1;
    const {data: input2} = loadable2;
    const output = func(input1, input2);
    result = {
      status: LoadableStatus.Present,
      data: output,
    };
  }
  return result;
};
